import { render, staticRenderFns } from "./NewFoldTree.vue?vue&type=template&id=6a193aae&scoped=true&"
import script from "./NewFoldTree.vue?vue&type=script&lang=ts&"
export * from "./NewFoldTree.vue?vue&type=script&lang=ts&"
import style0 from "./NewFoldTree.vue?vue&type=style&index=0&id=6a193aae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a193aae",
  null
  
)

export default component.exports